module.exports = __webpack_public_path__ + "img/dasha.6ebc3e56.jpg";